<ng-container *ngIf="enabled">
    <div class="actions">
        <button [disabled]="!companyId" mat-raised-button color="primary" (click)="addClient()">
            <mat-icon>add</mat-icon>
            Add new client
        </button>
    </div>
    <ng-container *ngIf="clients.data.length === 0">
        <app-inlinemessage class="info" level="warning" message="There are no clients assigned to this agency"></app-inlinemessage>
    </ng-container>
    <table mat-table matSort class="table" *ngIf="clients.data.length > 0" [dataSource]="clients">
        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Client Name</th>
            <td mat-cell *matCellDef="let item">{{item.name}}</td>
        </ng-container>
        <ng-container matColumnDef="city">
            <th mat-header-cell *matHeaderCellDef>City</th>
            <td mat-cell *matCellDef="let item">{{item.city}}</td>
        </ng-container>
        <ng-container matColumnDef="state">
            <th mat-header-cell *matHeaderCellDef>State</th>
            <td mat-cell *matCellDef="let item">{{item.state}}</td>
        </ng-container>
        <ng-container matColumnDef="actionmenu" stickyEnd>
            <th mat-header-cell matTooltip="Agency Actions" *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let item"><button mat-button class="cell" [matMenuTriggerFor]="menu" [matMenuTriggerData]="{item: item}"><mat-icon matTooltip="Actions" class="more">more_vert</mat-icon></button></td>
        </ng-container>
        <mat-menu #menu="matMenu">
            <ng-template matMenuContent let-item="item">
                <button mat-menu-item (click)="showClient(item)">Go To Client</button>
                <mat-divider></mat-divider>
                <button mat-menu-item (click)="editClient(item)">Edit Client</button>
                <button mat-menu-item (click)="removeClient(item)">Remove Client</button>
                <mat-divider></mat-divider>
                <button mat-menu-item (click)="setProducts(item)">Set Products for Client</button>
                <button mat-menu-item (click)="clearEnrollment(item)">Clear all Enrollment Data</button>
            </ng-template>
        </mat-menu>
        <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
        <tr mat-row *matRowDef="let rows; columns: columnsToDisplay"></tr>
    </table>
</ng-container>
